var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.125 7.22607C20.1058 7.22607 20.0771 7.22607 20.0483 7.22607C14.9788 6.71815 9.91876 6.52649 4.90668 7.0344L2.95168 7.22607C2.54918 7.2644 2.19459 6.9769 2.15626 6.5744C2.11793 6.1719 2.40543 5.8269 2.79834 5.78857L4.75334 5.5969C9.85168 5.0794 15.0171 5.28065 20.1921 5.78857C20.585 5.8269 20.8725 6.18149 20.8342 6.5744C20.8054 6.94815 20.4892 7.22607 20.125 7.22607Z",
    fill: "#667689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.14573 6.25812C8.1074 6.25812 8.06906 6.25812 8.02115 6.24853C7.63781 6.18145 7.36948 5.8077 7.43656 5.42437L7.6474 4.16895C7.80073 3.24895 8.01156 1.97437 10.2445 1.97437H12.7553C14.9978 1.97437 15.2086 3.29687 15.3524 4.17853L15.5632 5.42437C15.6303 5.81728 15.362 6.19103 14.9786 6.24853C14.5857 6.31562 14.212 6.04728 14.1545 5.66395L13.9436 4.41812C13.8095 3.58437 13.7807 3.42145 12.7649 3.42145H10.2541C9.23823 3.42145 9.21906 3.55562 9.07531 4.40853L8.8549 5.65437C8.7974 6.00895 8.49073 6.25812 8.14573 6.25812Z",
    fill: "#667689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.5763 22.5785H8.4238C5.07921 22.5785 4.94505 20.7289 4.83963 19.2339L4.21671 9.58346C4.18796 9.19054 4.49463 8.84555 4.88755 8.8168C5.29005 8.79763 5.62546 9.09471 5.65421 9.48763L6.27713 19.138C6.38255 20.5947 6.42088 21.141 8.4238 21.141H14.5763C16.5888 21.141 16.6271 20.5947 16.723 19.138L17.3459 9.48763C17.3746 9.09471 17.7196 8.79763 18.1125 8.8168C18.5055 8.84555 18.8121 9.18096 18.7834 9.58346L18.1605 19.2339C18.055 20.7289 17.9209 22.5785 14.5763 22.5785Z",
    fill: "#667689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.0907 17.3076H9.89941C9.5065 17.3076 9.18066 16.9818 9.18066 16.5889C9.18066 16.196 9.5065 15.8701 9.89941 15.8701H13.0907C13.4836 15.8701 13.8094 16.196 13.8094 16.5889C13.8094 16.9818 13.4836 17.3076 13.0907 17.3076Z",
    fill: "#667689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.8957 13.4744H9.104C8.71109 13.4744 8.38525 13.1485 8.38525 12.7556C8.38525 12.3627 8.71109 12.0369 9.104 12.0369H13.8957C14.2886 12.0369 14.6144 12.3627 14.6144 12.7556C14.6144 13.1485 14.2886 13.4744 13.8957 13.4744Z",
    fill: "#667689"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7b727068454288f9c9300a6a73089ffa.svg";
export { ForwardRef as ReactComponent };